"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedcouponsm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedcouponsm` : '') + (description ? ` desc-brandedcouponsm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedcouponsm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedcouponsm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.26 6h-4.38a.2.2 0 0 0-.19.2v.18c0 .43-.31.8-.72.82a.78.78 0 0 1-.8-.8v-.2a.2.2 0 0 0-.19-.2H1.74C1.4 6 1 6.42 1 6.79v11.26c0 .37.31.78.74.78h14.24a.2.2 0 0 0 .2-.2v-.18c0-.43.3-.8.71-.82.44-.02.8.35.8.8v.2c0 .11.08.2.19.2h4.38c.35 0 .74-.41.74-.78V6.79c0-.37-.4-.79-.74-.79ZM17.3 16.43a.4.4 0 0 1-.38.4.4.4 0 0 1-.38-.4v-.8c0-.23.17-.4.38-.4a.4.4 0 0 1 .38.4v.8Zm0-2.4a.4.4 0 0 1-.38.4.4.4 0 0 1-.38-.4v-.81c0-.22.17-.4.38-.4a.4.4 0 0 1 .38.4v.8Zm0-2.42a.4.4 0 0 1-.38.4.4.4 0 0 1-.38-.4v-.8c0-.22.17-.4.38-.4a.4.4 0 0 1 .38.4v.8Zm0-2.4a.4.4 0 0 1-.38.4.4.4 0 0 1-.38-.4v-.8c0-.23.17-.4.38-.4a.4.4 0 0 1 .38.4v.8Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.9 9.7H9.08c-.29 0-.56.1-.76.31-.2.2-.31.48-.31.77 0 1.64 2.9 1.64 2.9 3.27a1.05 1.05 0 0 1-1.07 1.1H8.01",
    stroke: "#FDF1F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.45 9.7V8.6",
    stroke: "#FDF1F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.5 15.2v1.09",
    stroke: "#FDF1F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var _default = exports.default = brandedcouponsm;